import Backdrop from "@mui/material/Backdrop";
import Image from "next/image";

const FullWidthLoader = ({ open }: { open: boolean }) => {
  return (
    <Backdrop
      sx={{ color: (theme) => theme.palette.custom.white, zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={open}
    >
      <Image src={"/images/Logo.svg"} alt="Image Not Found" height={100} width={100} />
    </Backdrop>
  );
};

export default FullWidthLoader;
